import React, { useEffect, useState } from "react";
import { CardContent, Grid, Typography } from "@material-ui/core";
import { Link } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import UsageChart from "./view/_usage-chart";
import { useSelector } from "react-redux";
import { store } from "../../../helpers/store";
import { usageService } from "./model/e_usage-service";
import { routePaths } from "../../config/route-paths";
import moment from "moment";
import { useTranslation } from "react-i18next";
import { Skeleton } from "@material-ui/lab";

const useStyle = makeStyles((theme) => ({
  cardContentStyle: {
    width: "100%",
  },
  usageSummaryHeader: {
    color: theme.palette.ePrimary?.base,
  },
  usageLink: {
    textAlign: "right",
    color: theme.palette.ePrimary?.base,
    textDecoration: "underline",
    fontSize: "0.875rem",
    paddingRight: "2.5%"
  },
  chartContainer: {
    marginTop: "0.5rem",
    padding: "0px"
  }
}));
export default function E_UsageSummary() {
  let classes = useStyle();
  const [data, setData] = useState();
  const [isLoading, setLoading] = useState(true);

  
  let accountId =useSelector((state) => state?.meterDetails?.accountId);
  let saId = useSelector((state) => state?.meterDetails?.getSaInfo?.saId);

  const {t:labels, ready: labelReady} = useTranslation("label-E_USAGE_SUMMARY");
  var startDate = moment()?.subtract("Days", 30)?.format("YYYY-MM-DD");
  var endDate = moment()?.format("YYYY-MM-DD");
  useEffect(() => {
    if (accountId && saId) {
      store.getState().snackbar = true
      setLoading(true);
      let data = usageService?.fetchChartData(accountId, saId, startDate, endDate, "D2BD", null)
        .then((response) => {
          if (response) {
            setData(response?.data?.getUsageTrends);
            setLoading(false);
          }
        }).catch((error) => {
          setData(null);
          setLoading(false);
        });
      store.getState().snackbar = false
    }
  }, [accountId, saId]);
  return (
    <CardContent className={classes?.cardContentStyle}>
        <Grid container spacing={0} >
          <Grid item xs={6} sm={12} md={6} >
          {
            labelReady ?
            <Typography variant="h6" className={classes?.usageSummaryHeader}><b>{labels("E_USAGE_SUMMARY_HEADER")}</b></Typography>
            : <Skeleton />
          }
          </Grid>
          <Grid xs={12} md={6} className={classes?.usageLink} align="end">
          {
            labelReady ?
            <Link to={routePaths.USAGE} className={classes?.usageLink} >{labels("E_USAGE_SUMMARY_VIEW_ALL_CONSUMPTION")}</Link>
            : <Skeleton />
          }
          </Grid>
        </Grid>
      <div className={classes?.chartContainer} alignItems="center">
        <UsageChart data={data} labels={labels} labelReady={labelReady} loading={isLoading} />
      </div>
    </CardContent>
  );
}
